import { generateTable } from '../../table/Table';
import { fetchOAuthClients } from '../../../apis';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('name', 'name').end();

var dataSource = function dataSource() {
  return {
    fn: fetchOAuthClients,
    clientSide: clientSide,
    params: function params() {
      return [];
    },
    transform: function transform(result) {
      return {
        data: result.oauthClients
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }];
  };
};

var columns = [{
  value: 'clientId',
  title: 'Client ID',
  sortable: true
}, {
  value: 'description',
  title: 'Description',
  sortable: false
}, {
  value: 'name',
  title: 'Name',
  sortable: true
}, {
  value: 'redirectUri',
  title: 'Redirect URI',
  sortable: true
}];
export var OAuthClientTable = generateTable({
  columns: columns,
  filters: filters,
  dataSource: dataSource
});
OAuthClientTable.displayName = 'OAuthClientTable';